/**
 * Перевод сохранённых значков на Font Awesome.
 *
 * До перехода категории хранили имена lucide, а самые старые — эмодзи;
 * счета — эмодзи. Выбор человека не теряется: значок переводится в иконку
 * того же смысла. Запись без старого значка возвращается как есть — тем же
 * объектом, по нему видно, что менять нечего.
 */
import { LEGACY_ACCOUNT_ICON } from '@skoka/core';
import { LEGACY_ICON } from './icon-pack.js';

const strip = (icon: string): string => icon.trim().replace(/️/g, '');

export function migrateCategoryIcon<T extends { icon?: string }>(category: T): T {
  if (!category.icon) return category;
  const next = LEGACY_ICON[category.icon.trim()] ?? LEGACY_ICON[strip(category.icon)];
  return next ? { ...category, icon: next } : category;
}

export function migrateAccountIcon<T extends { icon?: string }>(account: T): T {
  if (!account.icon) return account;
  const next = LEGACY_ACCOUNT_ICON[account.icon.trim()] ?? LEGACY_ACCOUNT_ICON[strip(account.icon)];
  return next ? { ...account, icon: next } : account;
}
